import { render, staticRenderFns } from "./ResultsInfo.vue?vue&type=template&id=616b2b4b&"
import script from "./ResultsInfo.vue?vue&type=script&lang=js&"
export * from "./ResultsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports